import { Backdrop } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GENERAL__CANCEL_BUTTON, GENERAL__YES, TRANSLATIONS__CONFIRM_DELETE } from 'translations/constants';
import {
  DeleteTranslationModalBox,
  ModalActionButton,
  ModalActionContainer,
  ModalContainer,
  ModalTitle,
} from './styles';

const DeleteTranslationModal = ({ isOpen, onClose, onConfirm }) => {
  const [t] = useTranslation();

  return (
    <Backdrop open={isOpen} sx={{ zIndex: '2000' }}>
      <DeleteTranslationModalBox open={isOpen} onClose={onClose}>
        <ModalContainer>
          <ModalTitle>{t(TRANSLATIONS__CONFIRM_DELETE)}</ModalTitle>
          <ModalActionContainer>
            <ModalActionButton text={t(GENERAL__YES)} onClick={onConfirm} />
            <ModalActionButton text={t(GENERAL__CANCEL_BUTTON)} outlined onClick={onClose} />
          </ModalActionContainer>
        </ModalContainer>
      </DeleteTranslationModalBox>
    </Backdrop>
  );
};

export default DeleteTranslationModal;
